<input type="file" #file style="display: none" [accept]="acceptExtensions == null ? undefined : _Utils.arrayItemsToString(acceptExtensions, ',')" (change)="_onFilesAdded()"/>
